var map = {
	"./Home": [
		6854,
		854
	],
	"./Home/": [
		6854,
		854
	],
	"./Home/index": [
		6854,
		854
	],
	"./Home/index.tsx": [
		6854,
		854
	],
	"./Privacy": [
		9062,
		62
	],
	"./Privacy/": [
		9062,
		62
	],
	"./Privacy/index": [
		9062,
		62
	],
	"./Privacy/index.tsx": [
		9062,
		62
	],
	"./Privacy/styles": [
		6382,
		382
	],
	"./Privacy/styles.ts": [
		6382,
		382
	],
	"./Terms": [
		59,
		59
	],
	"./Terms/": [
		59,
		59
	],
	"./Terms/index": [
		59,
		59
	],
	"./Terms/index.tsx": [
		59,
		59
	],
	"./Terms/styles": [
		8692,
		311
	],
	"./Terms/styles.ts": [
		8692,
		311
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 629;
module.exports = webpackAsyncContext;